import {RootState, useAppSelector} from "../../store";

// Stored cards are off unless the org config sets modules.savedPaymentMethods.enabled = true (CXTMS-474)
export const isSavedPaymentMethodsEnabled = (modules: any): boolean =>
  modules?.savedPaymentMethods?.enabled === true;

export const selectSavedPaymentMethodsEnabled = (state: RootState): boolean =>
  isSavedPaymentMethodsEnabled(state.organizationConfigState?.modules);

export const selectShowPaymentMethodsPage = (state: RootState): boolean =>
  selectSavedPaymentMethodsEnabled(state) &&
  !state.organizationConfigState?.modules?.profile?.paymentMethod?.disabled;

export const useSavedPaymentMethods = () => {
  const enabled = useAppSelector(selectSavedPaymentMethodsEnabled);
  return {savedPaymentMethodsEnabled: enabled};
};
